export const LINKS = {
  whatsapp:
    "https://wa.me/972586290452?text=Hi%20Zev%2C%20I'd%20love%20to%20learn%20more%20about%20Pines%20Retreat",
  instagram: 'https://www.instagram.com/pinesretreatspace',
  facebook: 'https://www.facebook.com/profile.php?id=61567128401247',
  airbnb: 'https://www.airbnb.com.au/rooms/42704474',
  booking: 'https://www.booking.com/hotel/il/tzimmer-b-kfar-htsymr-bkpr.html',
  googleMaps: 'https://share.google/rg5ti7y6oYuTbrujo',
}
